import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { LightningIcon } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { boostersFontCss, PremiumText } from '@root/entities/premium/ui'

import { PairActivitySnackbarBase } from './pair-activity-snackbar-base'

import type { PairActivity } from '../model'

type Props = {
  activity: PairActivity.BoostPurchased
  onClose?: () => void
}

export const PairActivitySnackbarBoost = ({ activity, onClose }: Props) => {
  const { currency } = activity

  return (
    <PairActivitySnackbarBase onClose={onClose} activity={activity}>
      <Root>
        <CurrencyDetails>
          <CurrencyIcon currency={currency} size={24} withNetwork />
          <Ticker>
            <PremiumText>{currency.ticker}</PremiumText>
          </Ticker>
        </CurrencyDetails>
        <Separator />
        <Message>
          <LightningIconGradient size={11} />
          <Trans
            i18nKey={'pair-activity.boost-purchased'}
            components={[<span key={0} />]}
            values={{
              count: activity.boostersAmount,
            }}
          />
        </Message>
      </Root>
    </PairActivitySnackbarBase>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 8px;
`

const CurrencyDetails = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
  justify-items: start;
  justify-content: start;
`

const Ticker = styled.span`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`

const Message = styled.span`
  color: var(--up-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2px;

  span {
    ${boostersFontCss}
    font-weight: 600;
  }
`

const Separator = styled.div`
  background: var(--backgroundA-4);
  width: 1px;
  height: 13px;
`

const LightningIconGradient = styled(LightningIcon)`
  color: var(--boostGradientFrom-11);
  margin-left: -3px;
`
